module.exports = "<div class=m-text><textarea placeholder=\"按 Ctrl + Enter 发送\" v-model=text @keyup=inputing></textarea></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/text.vue
 ** module id = 31
 ** module chunks = 0
 **/